__turbopack_context__.v({
  "statusCircle": "status-module-scss-module__fBtdxa__statusCircle",
});
